import { render, staticRenderFns } from "./TranslationForm.vue?vue&type=template&id=6b87df5d&scoped=true&"
import script from "./TranslationForm.vue?vue&type=script&lang=js&"
export * from "./TranslationForm.vue?vue&type=script&lang=js&"
import style0 from "./TranslationForm.vue?vue&type=style&index=0&id=6b87df5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b87df5d",
  null
  
)

export default component.exports